module.exports = __webpack_public_path__ + "img/b44.53115ef8.jpg";